import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';

/**
 * Guard that ensures only QuickActivated users can access the quick-activate route.
 * Redirects non-QuickActivated users to home.
 */
export const quickActivatedGuard = () => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  const isQuickActivated = storageService.getSessionStorage('is_quick_activated') === true;

  if (!isQuickActivated) {
    // Redirect non-QuickActivated users to home
    router.navigate(['/home']);
    return false;
  }

  // Allow QuickActivated users to proceed
  return true;
};
